import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'gitlab',
  version: '1.3.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
